module.exports = __webpack_public_path__ + "static/media/frog(15).5a1a3759.PNG";